module.exports = __webpack_public_path__ + "b2ac01268ecc7e6702baad813d8a2eaf.pdf";